import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../app/hooks';
import { selectUser } from '../store/slices/authSlice';

interface AdminGuardProps {
  children: React.ReactNode;
}

/**
 * Admin Guard component to protect admin-only routes
 * Redirects non-admin users to the dashboard
 */
const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const user = useAppSelector(selectUser);
  
  // Check if user is a superuser (admin)
  if (!user || !user.is_superuser) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <>{children}</>;
};

export default AdminGuard;
